import React from 'react';
import PropTypes from 'prop-types';
import xMarkIcon from './x-icon.svg';
import checkIcon from './check-icon.svg';
import {
  StyledComparisonChartItem,
  ChartItemHeader,
  HeaderThree,
  Paragraph,
  ChartItemIcons,
} from './styles';

export const ComparisonChartItem = ({ header, subheader = null }) => {
  return (
    <StyledComparisonChartItem>
      <ChartItemHeader>
        <HeaderThree>{header}</HeaderThree>
        {subheader && <Paragraph>{subheader}</Paragraph>}
      </ChartItemHeader>
      <ChartItemIcons>
        {/* eslint-disable @next/next/no-img-element */}
        <img src={xMarkIcon.src} alt="X Mark" />
        <img src={checkIcon.src} alt="Checked" />
        {/* eslint-enable @next/next/no-img-element */}
      </ChartItemIcons>
    </StyledComparisonChartItem>
  );
};

ComparisonChartItem.displayName = 'ComparisonChartItem';

ComparisonChartItem.propTypes = {
  header: PropTypes.string.isRequired,
  subheader: PropTypes.string,
};
